export default [
    {
      path: '/signDocument/signDocument',
      name: 'register',
      component: () => import('@/views/signDocument/signDocument.vue'),
      meta: {
        title: '签名',
      },
    }
  ];
  